export const CUSTOM_ASSISTANT_CHANNEL = "Chatbot";

export const getDynamicBrowserAssistantSetting = (
    configurationId: string,
    serverRootUrl: string,
    appId: string,
    appKey: string
) => {
    return {
        configurationId,
        serverRootUrl,
        appId,
        appKey,
        channel: CUSTOM_ASSISTANT_CHANNEL
    };
};

export const getDynamicSwiftCodeExport = (
    configurationId: string,
    serverRootUrl: string,
    appId: string,
    appKey: string
) => {
    return `AssistantDrawerUI(\n  assistantSettings:\n   AssistantSettingsProps(\n    configurationId: "${configurationId}", \n    serverRootUrl: "${serverRootUrl}", \n    appId: "${appId}", \n    appKey: "${appKey}", \n    channel: "${CUSTOM_ASSISTANT_CHANNEL}"\n   )\n)`;
};

export const getDynamicKotlinCodeExport = (
    configurationId: string,
    serverRootUrl: string,
    appId: string,
    appKey: string
) => {
    return `val voiceAssistant = AssistantDrawerUI.newInstance(\n  AssistantSettingsProps(\n   configurationId = "${configurationId}", \n   serverRootUrl = "${serverRootUrl}", \n   appId = "${appId}", \n   appKey = "${appKey}", \n   channel = "${CUSTOM_ASSISTANT_CHANNEL}"\n  )\n)`;
};
